<template>
  <div
    v-for="(player, index) in players"
    :key="index"
    class="as-player-item"
    :class="{
      'as-d-none as-d-md-flex': !isSmAll && screen === 'pc',
      'as-d-flex as-d-md-none': !isSmAll && screen === 'sm',
      'as-d-flex': isSmAll,
    }"
    :style="
      playerStyle(
        player.x || getPlayerDefault(index)?.x,
        player.y || getPlayerDefault(index)?.y
      )
    "
  >
    <img
      :alt="player.short_name || player.name"
      :src="getImgUrlBySport('player', player.id)"
      style="background: rgb(255, 255, 255)"
    />
    <SquadIncident
      v-if="player.incidents.length"
      :player="player"
      :types="[3, 4, 9, 15]"
      classname="as-incident-top"
    />
    <div
      v-if="player.rating && player.rating !== '0.0'"
      class="as-rating"
      :style="{ background: formatRateColor(parseFloat(player.rating)) }"
    >
      <div class="as-rating-text">
        {{ Number(player.rating).toFixed(1) }}
      </div>
    </div>
    <SquadIncident
      v-if="player.incidents.length"
      :player="player"
      :types="[1, 8, 17]"
    />
    <div class="as-shirt-number-player">
      <div class="as-shirt-number">{{ player.shirt_number }}</div>
      <span class="as-player-name as-w-o-h">{{ getPlayerNameShow(player, true) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import type { IPlayer } from "~src/interfaces";
import { formatRateColor, getPlayerNameShow } from "~src/helpers";
import SquadIncident from "~src/components/lineups/SquadIncident.vue";

interface IProps {
  screen: string;
  isSmAll: boolean; // chỉ Hiển thị sm
  players: Array<IPlayer>;
  teamType: string;
}

const props = withDefaults(defineProps<IProps>(), {
  screen: "pc",
  isSmAll: false,
  teamType: "home",
});

interface IPlayerDefaultItem {
  x: number;
  y: number;
}

const playerDefault: IPlayerDefaultItem[] = [
  { x: 50, y: 12 },  // Thủ môn
  { x: 12, y: 32 },  // Hậu vệ trái
  { x: 31, y: 32 },  // Hậu vệ trái giữa
  { x: 50, y: 32 },  // Hậu vệ giữa
  { x: 69, y: 32 },  // Hậu vệ phải giữa
  { x: 88, y: 32 },  // Hậu vệ phải
  { x: 24, y: 60 },  // Tiền vệ trái
  { x: 50, y: 60 },  // Tiền vệ giữa
  { x: 76, y: 60 },  // Tiền vệ phải
  { x: 35, y: 90 },  // Tiền đạo trái
  { x: 65, y: 90 },  // Tiền đạo phải
];

const getPlayerDefault = (index: any) => {
  return playerDefault[index];
};

const playerStyle = (x: number, y: number) => {
  if (props.screen === "sm") {
    const left = `calc(${x}% - 2.4em)`;
    const top = `calc(${y}% - 2.4em)`;

    if (props.teamType === "home") {
      return {
        left: left,
        top: top,
      };
    } else {
      return {
        right: left,
        top: top,
      };
    }
  } else {
    const left = `calc(${y}% - 2.7em)`;
    const bottom = `calc(${x}% - 2.3em)`;

    if (props.teamType === "home") {
      return {
        left: left,
        bottom: bottom,
      };
    } else {
      return {
        left: left,
        top: bottom,
      };
    }
  }
};
</script>

<script lang="ts">
export default {};
</script>
